/**
 * A restriction adapter used for testing primarily.
 * Will not resolve true until the specified time in ms passes.
 *
 * Define the restriction like so for a 5 second delay:
 *
 * delay:5000
 */

export const NAME = '^delay:(.+)$';

export default function isAllowed(restriction) {
	let [,match] = restriction.match(NAME);
	if (match) {
		let duration = parseInt(match, 10);
		if (!isNaN(duration)) {
			return new Promise((resolve) => {
				setTimeout(() => resolve(true), duration);
			});
		}
	}
	return Promise.resolve(true);
}


// WEBPACK FOOTER //
// ../node_modules/@cube/restrictions/src/adapters/delay/index.js